import UsersContent from "../../../components/Admin/Users"

const AdminUsers = () => {
    
    return (
        <>
            
            <UsersContent />

        </>
    )

}

export default AdminUsers